module.exports = __webpack_public_path__ + "6d8fdd8903a00603ed639d493c110fd5.MP3";